import React from "react";
import ReactApexChart from "react-apexcharts";

const PieUChart = ({
  phd = 0,
  nonPhd = 0,
  colors = ["#3A82EF", "#FF6B6B"],
  height = 200,
  width = 200,
  title = "نسبة حملة الدكتوراه",
}) => {
  const series = [phd, nonPhd];
  const options = {
    chart: {
      type: "donut",
      width,
    },
    labels: ["حملة الدكتوراه", "غير حملة الدكتوراه"],
    dataLabels: {
      enabled: true,
      style: {
        fontFamily: "Cairo",
        fontSize: "14px",
      },
    },
    stroke: {
      width: 2,
    },
    colors,
    legend: {
      position: "bottom",
      fontFamily: "Cairo",
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
  };

  return (
    <div className="mt-4 p-3 text-center">
      <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
      <ReactApexChart
        options={options}
        series={series}
        type="donut"
        height={height}
        width={width}
      />
    </div>
  );
};

export default PieUChart;
